import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch } = FiIcons;

const Header = () => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="app-header"
    >
      <div className="logo-container">
        <div className="logo">
          <img src="http://devserver.pressupwards.com/wp-content/uploads/2025/08/Screenshot-2025-08-02-at-10.02.21-PM.png" alt="KnowToConnect Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
        <span className="logo-text">KnowToConnect</span>
      </div>
      <div className="header-actions">
        <div className="search-container">
          <SafeIcon icon={FiSearch} className="search-icon" />
          <input type="text" placeholder="Search..." className="search-input" />
        </div>
      </div>
    </motion.header>
  );
};

export default Header;